module.exports = __webpack_public_path__ + "img/qx50-2025.0a4474f5.png";